export default {
  path: '/machines',
  name: 'machines',
  component: () => import('../components/machine/Layout'),
  redirect: { name: 'MachineList' },
  meta: {
    breadcrumb: 'machine.machines',
  },
  children: [
    {
      name: 'MachineList',
      path: '',
      component: () => import('../views/machine/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'MachineCreate',
      path: 'new',
      component: () => import('../views/machine/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'MachineUpdate',
      path: ':id/edit',
      component: () => import('../views/machine/Update'),
      meta: {
        breadcrumb: 'machine.machine',
      },
    },
    {
      name: 'MachineShow',
      path: ':id',
      component: () => import('../views/machine/Show'),
      meta: {
        breadcrumb: 'machine.machine',
      },
    }
  ]
};
